import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-dropdown', {
    position: 'relative',
    height: '23px',
});

cssRule('.tb-dropdown-button', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    padding: '1px 7px',
    cursor: 'pointer',
});

cssRule('.tb-dropdown-button:hover, .tb-dropdown-button:focus', {
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-dropdown-button.tb-selected:hover', {
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
});

cssRule('.tb-dropdown-text-selection', {
    height: '19px',
    lineHeight: '19px',
    marginLeft: '-6px',
    marginRight: '-6px',
    paddingLeft: '6px',
    paddingRight: '6px',
    color: 'inherit',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-dropdown-text-selection.tb-clearable', {
    paddingRight: '29px',
});

cssRule('.tb-dropdown-text-selection.tb-placeholder', {
    color: applyColor(DesignTokens.color.font.default.subtle, '#c0c0c0'),
});

cssRule('.tb-dropdown-list', {
    position: 'absolute',
    height: '149.5px',
    top: 0,
    left: 0,
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-dropdown-list .tb-dropdown-list-inner', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
});

cssRule('.tb-dropdown-list .tb-dropdown-list-inner .tb-scroll', {
    margin: '3px',
});

cssRule('.tb-dropdown-list strong', {
    fontStyle: 'normal',
    textDecoration: 'underline',
});

cssRule('.tb-row-count', {
    textAlign: 'right',
    minWidth: '37px',
});

